import {ValidateFunc} from '@/project'

/**
 * return Boolean
 * @param number
 */
const isCorpBizRNum: ValidateFunc = (number: any): boolean => {
  const RRN_MAX_LENGTH = 10
  // 사업자등록번호의 가운데 2자리는 개인/법인 구분
  const CHECK_NUM_INDEX = 3
  const CHECK_NUM_LENGTH = 2
  // 81,82,83,84,85,86,87,88 에 속하면 법인
  const CORP_MIN_NUM = 81
  const CORP_MAX_NUM = 88
  const RRN = number

  if(RRN.length !== RRN_MAX_LENGTH) {
    return false
  }
  const checkNum = Number(RRN.substr(CHECK_NUM_INDEX, CHECK_NUM_LENGTH))
  return checkNum >= CORP_MIN_NUM && checkNum <= CORP_MAX_NUM
}

export default isCorpBizRNum
